import Api from './api'

export default {
  forgotPassword(data) {
    return Api.post(`/password/email`, data)
  },
  resetPassword(data) {
    return Api.post(`/password/reset/` + data.token, data)
  },
  resendVerificationEmail() {
    return Api.get(`/email/resend/`)
  },
  verifyEmail(data) {
    return Api.get(`/email/verify/` + data.user + '?expires=' + data.expires + '&signature=' + data.signature)
  }
}
